import classnames from "classnames";
import type { PropsWithChildren, ReactNode } from "react";

interface DetailsItemProps {
  className?: string;
  title?: ReactNode;
}

const DetailsItem = ({
  className,
  title,
  children,
}: PropsWithChildren<DetailsItemProps>) => {
  return (
    <section className={classnames(className)}>
      {title && <h2 className="mb-4 text-section">{title}</h2>}
      <div className="whitespace-pre-wrap">{children}</div>
    </section>
  );
};

export default DetailsItem;
